// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"207":"ac961ee3","636":"a1d5f57f"}[chunkId] + ".chunk.css";
};